import { Formik, Form, Field, FieldArray } from 'formik';
import { useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router';
import * as Yup from 'yup';
import { API_BASE_URL, API_URL } from '../../utilities/constants';
import { handleApiCall, Label } from '../../utilities/helper';
import { useUI } from '../../context/UI';
import FileInput from '../../components/ui/FileInput';
import { CiCircleCheck, CiLocationArrow1 } from 'react-icons/ci';
import LoaderIcon from '../../components/ui/LoaderIcon';
import ButtonTextIcon from '../../components/ui/button/ButtonIconOnly';
import Button from '../../components/ui/button/Button';
import VoiceRecorder from '../../components/ui/VoiceRecorder';

const AddStylist = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const [image, setImage] = useState();
    const [uploadLoading, setUploadLoading] = useState(false);
    const [uploadedURL, setUploadedURL] = useState('');
    const [voiceSamples, setVoiceSamples] = useState([]);

    const handleSaveSample = (voiceUrl, toneDescription) => {
        setVoiceSamples((prev) => [
            ...prev,
            { toneDescription, voiceUrl }
        ]);
    };
    const {
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();
    const initialValues = {
        stylistName: "",
        persona: "",
        lingoStyle: "",
        tips: [""],
        voiceSamples: [
            { toneDescription: "", voiceUrl: "" }
        ],

    };
    const validationSchema = Yup.object().shape({
        stylistName: Yup.string().required('Name is required'),
        persona: Yup.string().required('Persona is required'),
        lingoStyle: Yup.string().required('LingoStyle is required'),

    });

    const handleUpload = async (fileToUpload = image) => {
        // if (!fileToUpload) return; // No file, exit early
        console.log('fileToUploadfileToUpload', fileToUpload)
        setUploadLoading(true);

        try {
            const formData = new FormData();
            formData.append("file", fileToUpload, fileToUpload.name); //  single file
            formData.append("type", "Stylist");

            const response = await fetch(
                `${API_BASE_URL}/api/1.0.0/files/uploadSystemFile`,
                {
                    method: "POST",
                    headers: {
                        "x-jwt-assertion": localStorage.getItem("token"), //  required header
                    },
                    body: formData,
                }
            );

            const responseData = await response.json();
            console.log("Upload response:", responseData);
            if (response.ok && responseData?.result?.responseCode === 200) {
                const uploadedUrl = responseData.data; //  directly string

                if (uploadedUrl) {
                    setUploadedURL(uploadedUrl);

                    addToastMessage({
                        status: true,
                        message: "Photo uploaded successfully!",
                    });

                    setNewNotification(true);
                    addNotification({
                        id: Date.now(),
                        message: "Photo uploaded successfully!",
                        status: true,
                        archive: false,
                    });
                }
            } else {
                addToastMessage({
                    status: false,
                    message:
                        responseData?.responseDescription ||
                        `Failed to upload ${fileToUpload.name}`,
                });
            }
        } catch (error) {
            console.error("Error uploading Photo:", error);
            addToastMessage({
                status: false,
                message: "Could not upload the photo at the moment.",
            });
            addNotification({
                id: Date.now(),
                message: "Could not upload the photo at the moment.",
                status: false,
                archive: false,
            });
            setNewNotification(true);
        } finally {
            setUploadLoading(false);
        }
    };

    const handleVoiceUpload = async (fileToUpload, index) => {
        if (!fileToUpload) return; //  exit if no file
        console.log("Uploading voice file:", fileToUpload);

        setUploadLoading(true);

        try {
            const formData = new FormData();
            formData.append("file", fileToUpload, fileToUpload.name);
            formData.append("type", "StylistVoice"); // Different type so backend can identify

            const response = await fetch(
                `${API_BASE_URL}/api/1.0.0/files/uploadSystemFile`,
                {
                    method: "POST",
                    headers: {
                        "x-jwt-assertion": localStorage.getItem("token"),
                    },
                    body: formData,
                }
            );

            const responseData = await response.json();
            console.log("Voice upload response:", responseData);

            if (response.ok && responseData?.result?.responseCode === 200) {
                const uploadedUrl = responseData.data; // real uploaded URL

                if (uploadedUrl) {
                    // update that voice sample in state
                    setVoiceSamples((prev) =>
                        prev.map((v, i) =>
                            i === index ? { ...v, voiceUrl: uploadedUrl } : v
                        )
                    );

                    addToastMessage({
                        status: true,
                        message: "Voice sample uploaded successfully!",
                    });

                    setNewNotification(true);
                    addNotification({
                        id: Date.now(),
                        message: "Voice sample uploaded successfully!",
                        status: true,
                        archive: false,
                    });
                }
            } else {
                addToastMessage({
                    status: false,
                    message:
                        responseData?.responseDescription ||
                        `Failed to upload ${fileToUpload.name}`,
                });
            }
        } catch (error) {
            console.error("Error uploading voice sample:", error);
            addToastMessage({
                status: false,
                message: "Could not upload voice sample at the moment.",
            });
            addNotification({
                id: Date.now(),
                message: "Could not upload voice sample at the moment.",
                status: false,
                archive: false,
            });
            setNewNotification(true);
        } finally {
            setUploadLoading(false);
        }
    };

  console.log('IMMg',image)
    const handleAddStylist = async (value) => {
        setLoading(true);
        try {
            const payload = {
                stylistName: value.stylistName,
                persona: value.persona,
                lingoStyle: value.lingoStyle,
                isActive: true,
                photoUrl: uploadedURL || "",
                tips: value?.tips?.filter(t => t && t.trim()) || [], 
                voiceSamples: voiceSamples.map(v => ({
                    toneDescription: v.toneDescription,
                    voiceUrl: v.voiceUrl.startsWith("blob:") ? "" : v.voiceUrl, // keep only real URLs
                })).filter(v => v.voiceUrl)

                // voiceSamples: voiceSamples.filter(v => v.toneDescription && v.voiceUrl)
            };
            console.log("Payload before API call:", JSON.stringify(payload, null, 2));
            console.log('payload', payload)

            const response = await handleApiCall(API_BASE_URL + "/api/1.0.0/aistylist/stylist", {
                method: "POST",
                body: payload,
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully created a Stylist, Thank You!",
                });
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully created a Stylist!",
                    status: true,
                    archive: false,
                });
                navigate(`/stylists`);
            }
            else {
                addToastMessage({
                    status: false,
                    message:
                        response?.responseDescription ||
                        "Something went wrong while creating a Stylist. Please try again!",
                });
            }
        } catch (e) {
            setNewNotification(true);
            addNotification({
                id: Date.now(),
                message: "Something went wrong while creating a Stylist.",
                status: false,
                archive: false,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleAddStylist}
        >
            {({ errors, touched, setFieldValue, values }) => (
                <Form className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-md max- mx-auto space-y-6">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <Label title='Stylist Name' />
                            <Field
                                name="stylistName"
                                type="text"
                                placeholder="Enter John"
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300   dark:text-gray-100 dark:bg-gray-800  "
                                    }`}
                            />
                            {errors.stylistName && touched.stylistName && (
                                <p className="text-xs text-red-500 mt-1">{errors.stylistName}</p>
                            )}
                        </div>

                        <div>
                            <Label title='Persona' />
                            <Field
                                name="persona"
                                type="text"
                                placeholder="Enter Persona"
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.transferType && touched.transferType
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600   dark:bg-gray-800 dark:text-gray-100"
                                    }`}
                            />
                            {errors.persona && touched.persona && (
                                <p className="text-xs text-red-500 mt-1">{errors.persona}</p>
                            )}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <Label title='Lingo Style' />
                            <Field
                                name='lingoStyle'
                                type='text'
                                placeholder='Eg: Hey gorgeous! '
                                className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring ${errors.country && touched.country
                                    ? "border-red-500 focus:ring-red-300"
                                    : "border-gray-300 focus:ring-brand-300 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
                                    }`}
                            />
                            {errors.lingoStyle && touched.lingoStyle && (
                                <p className="text-xs text-red-500 mt-1">{errors.lingoStyle}</p>
                            )}
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-end">
                        {/* File input */}
                        <div>
                            <Label title=' Photo Upload' />
                            <FileInput
                                ref={fileInputRef}
                                defaultText="Select Document"
                                accept="image/jpeg, image/jpg, image/png"
                                callback={(file) => setImage(file)}   // single file
                                value={image}
                            />

                        </div>

                        {/* Upload button */}
                        <div className="flex justify-end">
                            <ButtonTextIcon
                                type="button"
                                className={`px-4 py-2 rounded-lg shadow-md transition-colors duration-200 
                                        ${uploadedURL
                                        ? "bg-green-100 text-green-600 hover:bg-green-200"
                                        : "bg-brand-100 text-brand-600 hover:bg-brand-200"
                                    }`}
                                title={uploadedURL ? "Uploaded" : "Upload"}
                                icon={
                                    uploadLoading ? (
                                        <LoaderIcon className="animate-spin" />
                                    ) : uploadedURL ? (
                                        <CiCircleCheck className="text-xl" />
                                    ) : (
                                        <CiLocationArrow1 className="text-xl" />
                                    )
                                }
                                onClick={() => handleUpload(image)}
                            />
                        </div>
                    </div>
                    <div className="mb-6">
                        <Label title='Record a voice message' />
                        {/* <VoiceRecorder /> */}
                        {/* <VoiceRecorder o/nSave={handleSaveSample} /> */}
                        {/* <VoiceRecorder recordings={voiceSamples} onChange={setVoiceSamples} /> */}
                        {/* {voiceSamples.map((sample, index) => ( */}
                        <VoiceRecorder
                            recordings={voiceSamples}
                            onChange={setVoiceSamples}
                            onUpload={handleVoiceUpload}
                        />
                    </div>
                    <div>
                        <Label title='Tips' />
                        <FieldArray name="tips">
                            {({ push, remove }) => (
                                <div className="space-y-2">
                                    {values?.tips.map((tip, index) => (
                                        <div key={index} className="flex items-center gap-2">
                                            <Field
                                                name={`tips.${index}`}
                                                placeholder="Enter a tip"
                                                className="border rounded px-2 py-1 w-full dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100"
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();
                                                        push(""); // add new tip field
                                                    }
                                                }}
                                            />
                                            <Button
                                                type="button"
                                                variant="destructive"
                                                onClick={() => remove(index)}
                                                disabled={values.tips.length === 1} // keep at least one
                                            >
                                               <span className='dark:text-gray-200'>Remove</span>
                                            </Button>
                                        </div>
                                    ))}
                                    <Button
                                        type="button"
                                        variant="outline"
                                        // onClick={() => push("")}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            push("");
                                        }}
                                    >
                                        + Add Tip
                                    </Button>
                                </div>
                            )}
                        </FieldArray>
                    </div>

                    <div className="flex justify-end gap-3 pt-4">
                        <NavLink to='/stylists'>
                            <button
                                type="reset"
                                className="px-5 py-2 rounded-lg border border-gray-400 text-gray-600 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 transition"
                            >
                                Cancel
                            </button>
                        </NavLink>
                        <button
                            type="submit"
                            className="px-6 py-2 rounded-lg font-medium bg-brand-600 text-white hover:bg-brand-700 transition"
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            )}
        </Formik>

    );
};

export default AddStylist;


